export const getFileLoc = (
  s3Url: string,
  clientKey: string,
  path: string,
  thumbSize: '1152' | '768' | '512' | '256' | '128' | '64' | '' = '',
): string => `${s3Url}/${clientKey}/${path}${(thumbSize ? `/${thumbSize}/` : '/')}`;
